import { createAction } from 'redux-act'

type NotificationParams = {
  content: string
  type: 'error' | 'info'
  timespan?: number
}

export const showNotification = createAction<NotificationParams>('Show notification')
export const hideNotification = createAction('Hide notification')
